import { returnLocalisedPath } from '../../../../utils/globals';
import {
  collectionMicroDataAboutValues,
  collectionMicroDataMentionsValues,
} from './collectionMicroData.data';

export const collectionMicroData = (
  components,
  siteUrl,
  locale,
  url,
  category,
  seoMetadata
) => {
  const isFrenchLocale = locale.includes('fr');

  // Find all shop items in contentful data
  const returnShopItems = (array) => {
    const shopItems = [];
    const recursiveShopItemSearch = (arr) => {
      arr?.forEach((component) => {
        // Browse each component recursively
        if (component.internal?.type === 'ContentfulComponent') {
          recursiveShopItemSearch(component.items);
        } else if (component.internal?.type === 'ContentfulGrid') {
          component.gridItems?.forEach((gridItem) => {
            // Push every shop item present in grid
            if (gridItem.internal?.type === 'ContentfulShopItem') {
              shopItems.push(gridItem);
            }
          });
        }
      });
    };
    recursiveShopItemSearch(array);
    return shopItems;
  };

  const shopItems = returnShopItems(components);

  // Create EntityListItem From Page Shop Items
  const returnEntityListItems = shopItems.map((shopItem) => {
    const { categories, variants, subTitle, fields, slug } = shopItem?.product;
    const shopifyProduct = fields?.shopifyData;
    const shopifyProductVariant = shopifyProduct?.variants[0];
    const { sku, priceV2, selectedOptions } = shopifyProductVariant;
    const productUrl = `${siteUrl}/${
      process.env.GATSBY_ZONE
    }${returnLocalisedPath(locale, slug?.url || '')}`;
    const categoryTitle = categories && categories[0]?.title;

    const brand = {
      '@type': 'Brand',
      name: 'https://www.nooz-optics.com/',
    };

    const image = [
      `https:${variants && variants[0]?.posterImages[0]?.media?.file?.url}`,
    ];

    return {
      '@context': 'http://schema.org',
      '@type': 'Product',
      '@id': productUrl,
      name: shopifyProduct?.title,
      url: productUrl,
      productID: sku,
      sku,
      gtin13: sku,
      brand: brand,
      category: categoryTitle,
      material: categoryTitle,
      color: selectedOptions?.color,
      description: subTitle,
      image: image,
      model: shopifyProduct?.title,
      offers: {
        '@type': 'Offer',
        priceCurrency: priceV2?.currencyCode,
        availability: 'http://schema.org/InStock',
        priceValidUntil: '2099-01-01T00:00:00',
        url: productUrl,
        priceSpecification: {
          '@type': 'CompoundPriceSpecification',
          name: 'Price',
          price: priceV2?.amount,
          priceCurrency: priceV2?.currencyCode,

          priceComponent: [
            {
              name: 'VAT',
              price: priceV2?.amount,
              valueAddedTaxIncluded: true,
            },
          ],
        },
      },
    };
  });

  const collectionMicroDataToReturn = {
    '@context': 'http://schema.org',
    '@type': 'CollectionPage',
    '@id': url,
    url,
    name: category?.title,
    description: seoMetadata?.description?.description,
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: returnEntityListItems,
    },
  };

  return {
    ...collectionMicroDataToReturn,
    ...(isFrenchLocale &&
      category && {
        about: collectionMicroDataAboutValues[category.handle],
        mentions: collectionMicroDataMentionsValues[category.handle],
      }),
  };
};
